"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ListingReviewListModel_1 = require("./ListingReviewListModel");
var getReviews = function (listing) {
    return listing.getState("reviews", function () {
        return new ListingReviewListModel_1.ListingReviewListModel(listing);
    });
};
exports.getReviews = getReviews;
